module.exports = ($scope, $http, $filter, Api, countries, countryAliases, $state) ->
  $scope.mapping = {}
  $scope.countries = countries

  countries[i].aliases = countryAliases[country.name] for country, i in countries when countryAliases[country.name]?

  $scope.selection = {"country": null}

  $scope.goToCountry = (iso_code) ->
    $state.go('country-sources', {isoCode: iso_code})

  for country in countries
    if country.coverage_quality == 'MEDIUM' or country.coverage_quality == 'GOOD'
      $scope.mapping[country.iso_code.toUpperCase()] = 'full'
    else
      $scope.mapping[country.iso_code.toUpperCase()] = 'partial'
